import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as R from 'ramda';

import { DrawerLayoutWrapper } from 'common';
import ConfirmationMessage from './ConfirmationMessage';

const Heading = ({ title }) => (
  <Box sx={{ bgcolor: 'surface.swimlane', px: 2, py: 1 }}>
    <Typography variant="body1">{title}</Typography>
  </Box>
);
Heading.propTypes = { title: PropTypes.string.isRequired };

const Item = ({ label, value }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    sx={{ borderBottom: 1, borderColor: 'surface.swimlane', px: 2, py: 1.5 }}
  >
    <Typography variant="body1">{label}</Typography>
    <Typography variant="body1">{value}</Typography>
  </Stack>
);
Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const ConfirmationView = ({
  errorMessage,
  isCreatingNomination,
  nominationState,
  onComplete,
  onReset,
}) => {
  const { hasOnePossibleShipper, nominationMonth, products, segment, shipper } = nominationState;

  const buttons = (
    <>
      <Button onClick={onReset} startIcon={<AddIcon />} sx={{ flex: 1 }} variant="text">
        New Nomination
      </Button>
      <Button onClick={onComplete} sx={{ flex: 1, ml: 2 }}>
        Done
      </Button>
    </>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      onHeaderButtonClick={onComplete}
      title="New Monthly Nomination"
    >
      {isCreatingNomination ? (
        <Stack alignItems="center">
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <ConfirmationMessage errorMessage={errorMessage} />
          <Divider />
          <Stack>
            <Heading title="General Info" />
            {!hasOnePossibleShipper && (
              <Item label="Shipper" value={R.prop('customerNameShort', shipper)} />
            )}
            <Item label="Segment" value={R.prop('name', segment)} />
            <Item label="Nomination Month" value={R.prop('name', nominationMonth)} />
            {Object.values(products).map(({ name, volume }, i) => (
              <Fragment key={name}>
                <Heading title={`Monthly Nomination ${i + 1}`} />
                <Item label="Product Grade" value={name} />
                <Item label="Volume" value={`${volume} bbl`} />
              </Fragment>
            ))}
          </Stack>
        </>
      )}
    </DrawerLayoutWrapper>
  );
};

ConfirmationView.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  isCreatingNomination: PropTypes.bool.isRequired,
  nominationState: PropTypes.shape({
    hasOnePossibleShipper: PropTypes.bool,
    nominationMonth: PropTypes.shape({}),
    products: PropTypes.shape({}),
    segment: PropTypes.shape({}),
    shipper: PropTypes.shape({}),
  }).isRequired,
  onComplete: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default ConfirmationView;
